import { NavLink } from 'react-router-dom';
import chevronBackIcon from '@library/assets/images/icons/chevron-back-icon.svg';

export interface BackNavigationIconProps {
  className?: string;
  dataTestId?: string;
  path: string;
}

export const BackNavigationIcon = ({
  className = '',
  dataTestId = 'back-navigation',
  path
}: BackNavigationIconProps) => {
  return (
    <NavLink className={className} data-testid={dataTestId} to={path}>
      <img className="pr-2 pt-1" src={chevronBackIcon} alt="Navigate Back" />
    </NavLink>
  );
};
